import React, { ComponentProps } from "react";

function WifiIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={13}
      height={12}
      viewBox="0 0 13 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="network_wifi">
        <mask
          id="mask0_2907_1044969"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={13}
          height={12}
        >
          <rect
            id="Bounding box"
            x="0.5"
            width={12}
            height={12}
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_2907_1044969)">
          <path
            id="network_wifi_2"
            d="M3.15028 5.31231C3.61545 4.9069 4.13607 4.60844 4.71216 4.41694C5.28824 4.22544 5.88461 4.12969 6.50128 4.12969C7.11795 4.12969 7.71432 4.22544 8.29041 4.41694C8.86649 4.60844 9.38711 4.9069 9.85228 5.31231L10.7665 4.31881C10.148 3.86231 9.4762 3.51252 8.75103 3.26944C8.02586 3.02627 7.27595 2.90469 6.50128 2.90469C5.72661 2.90469 4.9767 3.02627 4.25153 3.26944C3.52636 3.51252 2.85453 3.86231 2.23603 4.31881L3.15028 5.31231ZM5.59528 9.72481L1.27191 5.05531C1.17082 4.94473 1.09828 4.82585 1.05428 4.69869C1.01028 4.57152 0.988281 4.43785 0.988281 4.29769C0.988281 4.13602 1.02007 3.98273 1.08366 3.83781C1.14724 3.6929 1.24261 3.56285 1.36978 3.44769C2.09695 2.87844 2.90128 2.44148 3.78278 2.13681C4.66428 1.83206 5.57045 1.67969 6.50128 1.67969C7.43211 1.67969 8.33828 1.83206 9.21978 2.13681C10.1013 2.44148 10.9056 2.87844 11.6328 3.44769C11.7599 3.56285 11.8553 3.6929 11.9189 3.83781C11.9825 3.98273 12.0143 4.13602 12.0143 4.29769C12.0143 4.43785 11.9923 4.57152 11.9483 4.69869C11.9043 4.82585 11.8317 4.94473 11.7307 5.05531L7.40728 9.72481C7.28261 9.86356 7.14257 9.96556 6.98716 10.0308C6.83174 10.0961 6.66978 10.1287 6.50128 10.1287C6.33278 10.1287 6.17082 10.0961 6.01541 10.0308C5.85999 9.96556 5.71995 9.86356 5.59528 9.72481Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default WifiIcon;
